import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { calculatorApi } from '../services/apiService';

interface CalculatorContextType {
  vatRate: number;
  isLoading: boolean;
}

const CalculatorContext = createContext<CalculatorContextType | undefined>(undefined);

export const CalculatorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [vatRate, setVatRate] = useState<number>(15);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchParameters = async () => {
      try {
        const data = await calculatorApi.getParameters();
        const vatParam = data.parameters.find((p) => p.name === 'vat_rate');
        if (vatParam) {
          setVatRate(parseFloat(vatParam.value));
        }
      } catch (error) {
        console.error('Error fetching parameters:', error);
        // Default to 15% VAT if fetch fails
        setVatRate(15);
      } finally {
        setIsLoading(false);
      }
    };

    fetchParameters();
  }, []);

  return (
    <CalculatorContext.Provider value={{ vatRate, isLoading }}>
      {children}
    </CalculatorContext.Provider>
  );
};

export const useCalculator = (): CalculatorContextType => {
  const context = useContext(CalculatorContext);
  if (context === undefined) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return context;
};
